import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Keeps the BRO projected delivery time block in sync with the selected variant, so the
 * availability state and the delivery estimate always describe the variant the customer
 * is about to add to cart.
 */
class BroDeliveryTime extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles the product select event by updating the delivery information.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        const incoming = blockId
          ? html.querySelector(`bro-delivery-time[data-block-id="${CSS.escape(blockId)}"]`)
          : html.querySelector('bro-delivery-time');

        if (!incoming) return;

        // `childrenOnly` leaves host attributes untouched, so mirror the one piece of
        // host state that depends on the variant: whether the block renders at all.
        this.toggleAttribute('hidden', incoming.hasAttribute('hidden'));

        morph(this, incoming, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[bro-delivery-time] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('bro-delivery-time')) {
  customElements.define('bro-delivery-time', BroDeliveryTime);
}
